/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import {getDepartmentByUserId, gettHeaderByType, settHeaderByType} from '@/api/common'
import {
    getCustomerConversionPublicList,

    setCustomerConversion,
    setCustomerConversionBackByCustomerConversionId,
    getMarketClueSourceList,
    getCustomerConversion, getCustomerConversionResaleList, setCustomerConversionResaleOrder,
} from '@/api/customer'
// import { TableHeader, TableRow } from './interface'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import realTimeSokcet from '@/utils/socket.io'
import {number} from "echarts";
import * as math from "mathjs";

@Component({})
export default class ResaleCustomer extends Vue {
    [x: string]: any
    socket: any = null
    tableHeadPopoverShow = false
    tableData = []
    tableHeader= []
    checkTableRow: any = []
    tableHeadFilter = {

        conversionName: '',
        marketClueName: '',
        weChat: '',
        level: '',
        followAt: '',
        attendSchool: '',
        specialized: '',
        targetSpecialized: '',
        followNum: '',
        createdAt: '',
        marketClueDirectorUserIdList: [],
        intentionalityList: [],
        gradeList: [],
        eduTemandList: [],
        marketClueSource: [],
        level2Scourse: [],
        createdUserIdList: [],
        leaderUserIdList: [],
        level2DepartmentId: null,
        directorLevel2DepartmentId: null,

    }
    followNumScopen = '' // 跟进次数范围
    followNumVal = '' // 跟进次数
    page = 1
    limit = 20
    total = 0
    selfTotal = 0
    // tableRandom = Math.random()
    receiverUser = ''
    editReceiverUserDialog = false
    sendBackDialog = false
    sendBackSelect = ''
    sendBackCause = ''
    sendBackOptions = [
        { value: '0', name: '退群' },
        { value: '1', name: '至少联系三次未联系上' },
        { value: '2', name: '非咨询科研项目' },
        { value: '3', name: '其他' }
    ]
    intentionalityName: any = {}
    loading = false
    sendBackClueID: number; // 退户线索id
    menuBtn = menuBtn
    cancelTabkBackClueDialog = false
    cancelTabkBackClueId: number
    sendBackDialogConfirmButtonDisabled = false
    exportBUttonDisabled = false
    /*新增*/
    ClueSourceList: any = []
    source = ''
    sourcePage = 1
    sourceLimit = 20

    deadline: Date = null // 截止时间
    startDate: Date = null
    endDate: Date = null // 计算得出最后的结束时间为什么时候
    followDialog = false
    // timePickerOptions = { start: '00:00', step: '01:00', end: "23:59" }
    // datePickerOptions = {
    //     disabledDate: (v: Date) => (true),
    // }
    time = ''
    selectValue = ''
    textValue = ''
    flag = false // 是否修改过时间没如果修改过就给后台传值
    isReceiveShow = false //都为1才显示批量跟进记录
    idList: any = [] //批量跟进id
    marketClueSourceList = []
    tableKey = Math.random()
    timer = null
    vdaH = 0 //屏幕高度
    originHeight: any = '' //屏幕高度
    heightScroll = false
    popHeight = 0
    draggableList = []
    draggableListChange = []
    dialogShow = false
    level2DepartmentList = [
        {name: '北京咨询部', id: 1047},
        {name: '上海咨询部', id: 1048},
        {name: '深圳咨询部', id: 1049},
        {name: '成都咨询部', id: 1065},
        {name: '广州咨询部', id: 1143},
        {name: '苏州咨询部', id: 1146}
    ]
    formRules = {}
    formData = {
        cooperationName: '',
        cooperaitonPrice: '',
        ratio: '',
        price: '',
        directorUserId: '',
        contractUrl: '',
        customer : '',
        createdUserRealName:'',
    }
    resaleId = null
    fileList = []
    fileId = ''
    contractLoading = false
    previewVisible = false
    previewPath = ''
    eduTemandOptions = ['留学', '高考', '考研', '保研', '考博', '无升学需求']
    gradeOptions = [
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）',
        '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业',
        '待定',
        '7年级以下'
    ]
    intentionalityList = [
        {label:'A',value:'A',interpretation:'（7天内签约）'},
        {label:'B',value:'B',interpretation:'（15天内签约）'},
        {label:'C',value:'C',interpretation:'（30天内签约）'},
        {label:'D',value:'D',interpretation:'（90天内签约）'},
        {label:'E',value:'E',interpretation:'（长期跟进）'},
        {label:'F',value:'F',interpretation:'（流失并调入公海）'},
        {label:'已签约',value:'已签约',interpretation:''},
    ] // 客户意向度

    // computed
    get userList() {
        return UserModule.userList
    }

    get userId() {
        return UserModule.userId
    }

    get UserName() {
        return UserModule.userName
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    get userName() {

        return UserModule.userName
    }



    // created
    created() {
        this.getTableHeader()
        // this.getMarketClueSourceList()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
    }

    thisCoopraitonPriceChange( val) {
        val = this.handleCooperaitonOnInput(val, '2')
        this.formData.cooperaitonPrice = this.handleCooperaitonOnInput(val, '2')
    }
    handleCooperaitonOnInput(num,limit){
        const len1 = num.charAt(0)
        // 转化为数字形式--包含小数，负数
        // 先把非数字的都替换掉，除了数字和.
        num = num.replace(/[^\d.]/g, '')
        // 必须保证第一个为数字而不是.
        num = num.replace(/^\./g, '')
        // 保证只有出现一个.而没有多个.
        num = num.replace(/\.{2,}/g, '.')
        // 保证.只出现一次，而不能出现两次以上
        num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // 如果第一位是负号，则允许添加
        if (len1 === '-') {
            num = '-' + num
        }
        return num
    }

    clearClueSource() {
        this.filterSourceName = ''
        this.source = null
        this.sourcePage = 1
        this.sourceLimit = 20
        this.getMarketClueSourceList()
    }

    changeRatio(val) {
        val = this.handleCooperaitonOnInput(val, '2')
        this.formData.ratio = this.handleCooperaitonOnInput(val, '2')

        const num1: any = Number(this.formData.cooperaitonPrice)
        const num2: any = Number(val)
        const val1: any = math.number(math.multiply(math.bignumber(num1), math.bignumber(num2)))
        const val2: any = math.number(math.divide(math.bignumber(val1), math.bignumber(100) as any))
        this.formData.price = String(val2)
    }

    beforeUpload(file) {
        this.contractLoading = true;//上传时显示
        // this.$message("正在上传中，请稍后")
    }

    handleChange(file, fileList) {
        if (fileList.length > 1) {
            this.fileList = [file]; // 限制只保留最新添加的文件
        }
    }

    uploadSuccess(res) {
        const {data} = res
        this.formData.contractUrl = data.ossUrl
        console.log(
            'data.ossUrl',data.ossUrl
        )
        this.$message.success('上传成功')
        this.contractLoading = false
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    handlePreview(file) {
        if (file.response) {
            this.previewPath = file.response.data.url
        } else {
            this.previewPath = file.url
        }
        this.previewName = file.name
        this.previewVisible = true
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    dialogCancle(){
        this.dialogShow = false
        this.formData.cooperationName = ''
        this.formData.cooperaitonPrice = ''
        this.formData.ratio = ''
        this.formData.price = ''
        // this.formData.directorUserId = ''
        this.formData.contractUrl = ''
    }

    async dialogConfirm() {
        if(!this.formData.contractUrl||!this.formData.cooperaitonPrice||!this.formData.ratio||!this.formData.directorUserId){
            this.$message.error('请将信息填写完整')
            return ;
        }
        await setCustomerConversionResaleOrder({
            id: this.resaleId,
            cooperationName: this.formData.cooperationName,
            cooperaitonPrice: this.formData.cooperaitonPrice,
            ratio: this.formData.ratio,
            price: this.formData.price,
            directorUserId: this.formData.directorUserId,
            contractUrl: this.formData.contractUrl,
        })
        this.getTableData()
        this.$message.success('成交订单')
        this.dialogShow = false
        this.formData.cooperationName = ''
        this.formData.cooperaitonPrice = ''
        this.formData.ratio = ''
        this.formData.price = ''
        // this.formData.directorUserId = ''
        this.formData.contractUrl = ''
        this.fileList = []

    }

    // methods
    async getTableHeader() {
        console.log('111',)
        this.loading = true
        const data: any = await gettHeaderByType(19)

        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
    }




    async getTableData() {
        this.loading = true
        this.tableHeadFilter.followNum = this.followNumScopen + this.followNumVal
        const obj = this.removePropertyOfNull({
            ...this.tableHeadFilter,
            page: this.page,
            limit: this.limit
        })
        const data: any = await getCustomerConversionResaleList(obj)

        this.tableData = data.customerConversionResaleList
        this.total = data.allNum
        this.tableKey = Math.random()

        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
        this.loading = false

    }

    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/pubCustomerStatic')
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 17})
            this.$message.success('设置成功')
            this.tableHeadPopoverShow = false
            this.getTableHeader()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }
    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false

    }


    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    ClickTableRow(row: any, col: any) {
        if (col.label !== '操作' ) { // && menuBtn(206)
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/resaleCustomerInfo?id=' + row.id)
            const time = setInterval(() => {
                if(win.closed) {
                    this.getTableData()
                    clearInterval(time)
                }
            }, 500)
        }
    }
    async receiveMarketClue(id: number) {
        await setCustomerConversion(id)
        this.$message.success('成功接收线索')
        this.getTableData()
    }


    initSocket() {
        const time = setInterval(() => {
            if(Vue.prototype.$socket.on) {
                realTimeSokcet(this.userId, 'MarketClue', this.getTableData)
                clearInterval(time)
            }
        }, 100)
    }


    clickFollow(row: any) {

        this.resaleId = row.id
        this.formData.customer = row.realName
        this.dialogShow = true

    }

    clickCancelBack(row) {
        this.cancelTabkBackClueId = row.id
        this.cancelTabkBackClueDialog = true
    }


    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if ((obj[item] === '' || !obj[item] || obj[item].length === 0) && obj[item] !== 0) {
                delete obj[item]
            }
        })
        return obj;
    }








    async handleClueSource() {
        if ((this.ClueSourceList.length == 0 || !this.source) && !this.tableHeadFilter.marketClueSource) {
            this.source = null
            this.sourcePage = 1
            // this.sourceLimit = 20
            const result: any = await getMarketClueSourceList(
                {
                    page: this.sourcePage,
                    limit: this.sourceLimit,
                    source: this.source
                }
            )
            this.ClueSourceList = result.marketClueSourceList
        }

    }

    handleClueSourceBlur(e) {
        this.source = null
        this.sourcePage = null
        this.sourceLimit = null
        this.getMarketClueSourceList()
    }

    async remoteMethod(query: any) {
        this.source = query
        this.sourcePage = 1
        this.sourceLimit = 20
        if (query !== '') {
            const result: any = await getMarketClueSourceList({
                page: this.sourcePage,
                limit: this.sourceLimit,
                source: query
            })
            this.ClueSourceList = result.marketClueSourceList
        } else {
              this.ClueSourceList = []
              this.getMarketClueSourceList()
        }
    }

    loadmore() {
        this.sourcePage = 1
        this.sourceLimit += 20
        this.getMarketClueSourceList();
    }



    changeClueSource(val) {
        // this.tableHeadFilter.marketClueSource = val
        this.marketClueSourceList = val
    }


    @Watch('userId')
    handleUserIdChange() {
        if(!this.formData.directorUserId) {
            this.formData.directorUserId = this.userId
        }
    }
}
